import React from "react";

const About = () => {
  const links = [
    { name: "Pourquoi choisir Payor ?", href: "#" },
    { name: "Nos fonctionnalités", href: "#" },
    { name: "Témoignages clients", href: "#" },
    { name: "Nous contacter", href: "#" },
  ];

  const stats = [
    { name: "Entreprises accompagnées", value: "1 200+" },
    { name: "Salariés gérés", value: "50 000+" },
    { name: "Pays couverts", value: "15" },
    { name: "Conformité légale", value: "100%" },
  ];

  return (
    <section className="relative isolate overflow-hidden bg-neutral-900 py-24 sm:py-32 text-white">
      {/* Image de fond Payor */}
      <img
        src="https://images.pexels.com/photos/3184460/pexels-photo-3184460.jpeg?auto=compress&cs=tinysrgb&w=1600"
        alt="Gestion de paie en Afrique"
        className="absolute inset-0 -z-10 w-full h-full object-cover opacity-30"
      />

      <div className="container mx-auto max-w-7xl px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-5xl font-bold sm:text-7xl">À propos de Payor</h2>
          <p className="mt-6 text-lg text-gray-300">
            Payor est la **référence N°1 en gestion de la paie en Afrique Francophone**.  
            Notre plateforme simplifie et automatise le processus de paie,  
            garantissant **conformité légale, rapidité et fiabilité** pour les entreprises de toutes tailles.
          </p>
        </div>

        {/* Liens utiles */}
        <div className="mt-10 flex flex-wrap justify-center gap-6 text-lg font-semibold">
          {links.map((link) => (
            <a key={link.name} href={link.href} className="text-blue-500 hover:text-blue-300">
              {link.name} &rarr;
            </a>
          ))}
        </div>

        {/* Statistiques de Payor */}
        <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat) => (
            <div key={stat.name} className="text-center">
              <dd className="text-4xl font-bold">{stat.value}</dd>
              <dt className="text-lg text-gray-400">{stat.name}</dt>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
